/* SAFA V9 · Conversion Max */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = window.theme || {};
  var V = T.v9 || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function fmt(c) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: V.currency || 'EUR' }).format((Number(c) || 0) / 100); }
    catch (e) { return ((Number(c) || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function load(k) { try { return JSON.parse(localStorage.getItem(k)) || {}; } catch (e) { return {}; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* Offer picker */
  function initPickers() {
    $$('[data-v9-picker]').forEach(function (p) {
      if (p.dataset.ready) return;
      p.dataset.ready = '1';
      var form = $('[data-v9-form]', p), price = $('[data-v9-atc-price]', p), err = $('[data-v9-error]', p), buy = $('[data-v9-buynow]', p);
      if (!form) return;
      function sync() {
        var r = $('input[name=quantity]:checked', form);
        if (!r) return;
        if (price) price.textContent = fmt(r.dataset.v9Total);
        document.dispatchEvent(new CustomEvent('v9:tier', { detail: { picker: p, title: r.dataset.v9Title, total: r.dataset.v9Total } }));
      }
      form.addEventListener('change', sync);
      form.addEventListener('theme:product-error', function (e) { if (err) err.textContent = (e.detail && e.detail.message) || 'Ajout impossible pour le moment.'; });
      form.addEventListener('theme:product-added', function () { if (err) err.textContent = ''; });
      if (buy) buy.addEventListener('click', function () {
        if (buy.disabled) return;
        var label = buy.textContent;
        buy.disabled = true; buy.textContent = 'Redirection vers le paiement…';
        if (err) err.textContent = '';
        fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Ajout impossible pour le moment.'); window.location.assign(ROOT + 'checkout'); }); })
          .catch(function (e) { if (err) err.textContent = e.message; buy.disabled = false; buy.textContent = label; });
      });
      sync();
    });
  }

  /* Sticky add to cart */
  function initSticky() {
    var bar = $('[data-v9-sticky]'), p = $('[data-v9-picker]');
    if (!bar || !p) return;
    var t = $('[data-v9-sticky-title]', bar), pr = $('[data-v9-sticky-price]', bar), btn = $('[data-v9-sticky-btn]', bar);
    function set(title, total) { if (t) t.textContent = title || ''; if (pr) pr.textContent = fmt(total); }
    var r = $('input[name=quantity]:checked', p);
    if (r) set(r.dataset.v9Title, r.dataset.v9Total);
    document.addEventListener('v9:tier', function (e) { if (e.detail.picker === p) set(e.detail.title, e.detail.total); });
    var inView = true, past = false;
    function upd() {
      var show = !inView && past;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('v9-sticky-on', show);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; upd(); }, { threshold: 0.1 }).observe(p);
    window.addEventListener('scroll', function () { var np = window.scrollY > window.innerHeight * 0.5; if (np !== past) { past = np; upd(); } }, { passive: true });
    if (btn) btn.addEventListener('click', function () {
      var form = $('[data-v9-form]', p), atc = form ? $('[data-v9-atc]', form) : null;
      if (!atc || atc.disabled) { p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
    upd();
  }

  /* Scroll to offer */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-v9-scroll-offer],[data-hs4-final-buy]');
    if (!a) return;
    var p = $('[data-v9-picker]');
    if (!p) return;
    e.preventDefault();
    if (window.v9CloseWheel) window.v9CloseWheel();
    p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  });

  /* Delivery estimate */
  function initEta() {
    $$('[data-v9-eta]').forEach(function (el) {
      var min = Number(el.dataset.min) || 2, max = Number(el.dataset.max) || 4;
      function add(n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
      function f(d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
      el.textContent = 'entre le ' + f(add(min)) + ' et le ' + f(add(max));
    });
  }

  /* Cart drawer ladder */
  function priceFor(q) {
    if (q <= 0) return 0;
    var grp = (V.bxgyBuy || 0) + (V.bxgyGet || 0), free = 0;
    if (grp > 0 && q >= grp) { free = Math.floor(q / grp) * V.bxgyGet; if (V.bxgyMax) free = Math.min(free, V.bxgyMax * V.bxgyGet); }
    var t = (q - free) * (V.unit || 0);
    if (V.bulkQty && q >= V.bulkQty) t -= (V.bulkOff || 0);
    return Math.max(0, t);
  }
  function initLadder() {
    var box = $('[data-v9-ladder]');
    if (!box || !V.variantId) return;
    var msg = $('[data-v9-ladder-msg]', box), fill = $('[data-v9-ladder-fill]', box), btn = $('[data-v9-ladder-add]', box), steps = $$('[data-v9-step]', box);
    var t2 = V.t2Qty || 3, t3 = V.t3Qty || 6;
    document.addEventListener('herat:cart-rendered', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      var sav = $('[data-v9-savings]');
      if (sav) { var d = Number(cart.total_discount || 0); sav.hidden = d <= 0; var s = $('strong', sav); if (s) s.textContent = fmt(d); }
      var q = cart.items.filter(function (i) { return String(i.variant_id) === String(V.variantId); }).reduce(function (a, i) { return a + i.quantity; }, 0);
      if (!q) { box.hidden = true; return; }
      box.hidden = false;
      steps.forEach(function (s) { s.classList.toggle('is-done', q >= Number(s.dataset.v9Step)); });
      var pct = q >= t3 ? 100 : q >= t2 ? 50 + 50 * (q - t2) / (t3 - t2) : 50 * (q - 1) / Math.max(1, t2 - 1);
      if (fill) fill.style.width = Math.min(100, Math.max(4, pct)) + '%';
      var text = '', add = 0, delta;
      if (q < t2) {
        add = t2 - q; delta = priceFor(t2) - priceFor(q);
        text = add === 1 ? 'Votre ' + t2 + 'e pot est offert : ajoutez-le, il ne vous coûte rien.' : 'Ajoutez ' + add + ' pots : le ' + t2 + 'e est offert et la livraison aussi.';
        btn.textContent = delta <= 0 ? 'Ajouter mon pot offert' : 'Passer à ' + t2 + ' pots (+' + fmt(delta) + ')';
      } else if (q < t3) {
        add = t3 - q; delta = priceFor(t3) - priceFor(q);
        text = delta < 0 ? 'Passez à ' + t3 + ' pots et payez ' + fmt(-delta) + ' de moins qu’aujourd’hui.' : 'Passez à ' + t3 + ' pots : ' + fmt(Math.round(priceFor(t3) / t3)) + ' le gramme, notre meilleur prix.';
        btn.textContent = 'Passer à ' + t3 + ' pots (' + (delta < 0 ? '−' + fmt(-delta) : '+' + fmt(delta)) + ')';
      } else {
        text = 'Meilleur prix débloqué : ' + fmt(Math.round(priceFor(q) / q)) + ' le gramme.';
      }
      if (msg) msg.textContent = text;
      btn.hidden = !add;
      btn.dataset.qty = add;
    });
    btn.addEventListener('click', function () {
      var qty = Number(btn.dataset.qty) || 0;
      if (!qty || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Ajout…';
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: V.variantId, quantity: qty }), credentials: 'same-origin' })
        .then(function () { var tg = $('[data-cart-toggle]'); if (tg) tg.click(); })
        .catch(function () { btn.textContent = label; })
        .finally(function () { btn.disabled = false; });
    });
  }

  /* Gift wheel */
  function buildWheel(disc, segs) {
    var ns = 'http://www.w3.org/2000/svg', n = segs.length, a = 360 / n;
    var fills = ['#5A0C1B', '#FFF6E4', '#F1B43F', '#35070E', '#AFC58F', '#FFFDF7'];
    var inks = ['#FFF6E4', '#5A0C1B', '#35070E', '#F1B43F', '#211512', '#5A0C1B'];
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '-100 -100 200 200'); svg.setAttribute('aria-hidden', 'true');
    segs.forEach(function (s, i) {
      var a0 = (i * a - 90) * Math.PI / 180, a1 = ((i + 1) * a - 90) * Math.PI / 180;
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M0 0 L' + (96 * Math.cos(a0)).toFixed(2) + ' ' + (96 * Math.sin(a0)).toFixed(2) + ' A96 96 0 ' + (a > 180 ? 1 : 0) + ' 1 ' + (96 * Math.cos(a1)).toFixed(2) + ' ' + (96 * Math.sin(a1)).toFixed(2) + ' Z');
      path.setAttribute('fill', fills[i % fills.length]); path.setAttribute('stroke', '#35070E'); path.setAttribute('stroke-width', '0.6');
      svg.appendChild(path);
      var g = document.createElementNS(ns, 'g');
      g.setAttribute('transform', 'rotate(' + ((i + 0.5) * a) + ')');
      var label = String(s.label), cut = label.length > 8 ? label.lastIndexOf(' ') : -1;
      var lines = cut > 0 ? [label.slice(0, cut), label.slice(cut + 1)] : [label];
      lines.forEach(function (line, k) {
        var tx = document.createElementNS(ns, 'text');
        tx.setAttribute('x', '0'); tx.setAttribute('y', String((lines.length > 1 ? -68 : -62) + k * 12));
        tx.setAttribute('text-anchor', 'middle'); tx.setAttribute('fill', inks[i % inks.length]);
        tx.setAttribute('font-size', lines.length > 1 ? '9.5' : '11'); tx.setAttribute('font-weight', '800'); tx.setAttribute('font-family', 'Manrope, sans-serif');
        tx.textContent = line; g.appendChild(tx);
      });
      svg.appendChild(g);
    });
    disc.appendChild(svg);
  }
  function initWheel() {
    var modal = $('[data-v9-wheel]'), conf = $('#v9-wheel-config');
    if (!modal || !conf) return;
    var W; try { W = JSON.parse(conf.textContent); } catch (e) { return; }
    var segs = (W.segments || []).filter(function (s) { return s && s.label && s.code && Number(s.weight) > 0; });
    if (segs.length < 2) return;
    var KEY = 'safa_v9_wheel', disc = $('[data-v9-wheel-disc]', modal), form = $('[data-v9-wheel-form]', modal);
    var stepForm = $('[data-v9-wheel-step=form]', modal), stepRes = $('[data-v9-wheel-step=result]', modal);
    var teaser = $('[data-v9-wheel-teaser]'), teaserLabel = teaser ? $('[data-v9-wheel-teaser-label]', teaser) : null;
    var isOpen = false, fired = false, last = null;
    buildWheel(disc, segs);

    function teaserUpdate() { if (!teaser) return; var st = load(KEY); if (teaserLabel) teaserLabel.textContent = st.code ? 'Votre code : ' + st.code : 'Votre cadeau vous attend'; }
    function showResult(seg) {
      if (stepForm) stepForm.hidden = true;
      if (stepRes) stepRes.hidden = false;
      var pz = $('[data-v9-wheel-prize]', modal), cd = $('[data-v9-wheel-code]', modal);
      if (pz) pz.textContent = seg.label;
      if (cd) cd.textContent = seg.code;
    }
    function open() {
      if (isOpen) return;
      isOpen = true; fired = true; last = document.activeElement;
      var st = load(KEY);
      if (st.code) showResult(st);
      modal.hidden = false;
      document.body.classList.add('v9-lock');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      var f = $('input[type=email]', modal);
      if (f && !st.code) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 180);
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      modal.classList.remove('is-open');
      document.body.classList.remove('v9-lock');
      setTimeout(function () { modal.hidden = true; }, 260);
      var st = load(KEY);
      if (!st.code) { st.dismissed = Date.now(); save(KEY, st); }
      if (teaser) teaser.hidden = false;
      teaserUpdate();
      if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) {} }
    }
    window.v9CloseWheel = close;

    function spin(btn) {
      var total = segs.reduce(function (s, x) { return s + Number(x.weight); }, 0), r = Math.random() * total, idx = 0;
      for (var i = 0; i < segs.length; i++) { r -= Number(segs[i].weight); if (r <= 0) { idx = i; break; } }
      var a = 360 / segs.length, jitter = (Math.random() - 0.5) * a * 0.6;
      var rot = (reduce ? 1 : 6) * 360 + (360 - (idx + 0.5) * a) + jitter;
      disc.style.transition = reduce ? 'transform .6s ease-out' : 'transform 5.4s cubic-bezier(.12,.7,.1,1)';
      disc.style.transform = 'rotate(' + rot + 'deg)';
      var done = false;
      function finish() {
        if (done) return; done = true;
        var seg = segs[idx];
        save(KEY, { code: seg.code, label: seg.label, t: Date.now() });
        fetch(ROOT + 'discount/' + encodeURIComponent(seg.code), { credentials: 'same-origin' }).catch(function () {});
        showResult(seg);
        teaserUpdate();
        if (btn) btn.disabled = false;
      }
      disc.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, reduce ? 900 : 5900);
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.reportValidity && !form.reportValidity()) return;
      var btn = $('button[type=submit]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'La roue tourne…'; }
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).catch(function () {});
      spin(btn);
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-v9-wheel-close]')) { e.preventDefault(); close(); } });
    document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });
    var copy = $('[data-v9-wheel-copy]', modal);
    if (copy) copy.addEventListener('click', function () {
      var code = ($('[data-v9-wheel-code]', modal) || {}).textContent || '';
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copy.textContent = 'Copié'; setTimeout(function () { copy.textContent = 'Copier'; }, 1800); });
    });
    if (teaser) teaser.addEventListener('click', open);

    var st = load(KEY), snooze = (W.snoozeDays || 7) * 864e5;
    teaserUpdate();
    if (st.code || (st.dismissed && Date.now() - st.dismissed < snooze)) { if (teaser) teaser.hidden = false; return; }
    var armed = false;
    setTimeout(function () { armed = true; }, 5000);
    function fire() {
      if (fired || isOpen) return;
      if (document.body.classList.contains('cart-open')) { setTimeout(fire, 4000); return; }
      open();
    }
    setTimeout(fire, (Number(W.delay) || 12) * 1000);
    document.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY < 10) fire(); });
    window.addEventListener('scroll', function () { if (!armed) return; var h = document.documentElement; if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.6) fire(); }, { passive: true });
  }

  function init() { initPickers(); initSticky(); initEta(); initLadder(); initWheel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initPickers(); initEta(); });
})();
